import Vue from 'vue';
import Component from 'vue-class-component';
import SketchfabFrame from '../sketchfabFrame/SketchfabFrame.vue';
import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';

import * as _ from 'lodash';
import ProductSelector from '@/components/productSelector/ProductSelector';
import { ProductDefinition, AnimationDefinition } from '@/models/configuratorx/configuratorSchema';
import Toggle from '@/components/parts/Toggle';

import PartsColor from '@/components/partsColor/PartsColor';



@Component({
  components: {
    toggle: Toggle,
    partsColor: PartsColor,
  },
})
export default class GenesisTakim extends Vue {
  private _configuratorService: ConfiguratorService = undefined;


  @Inject()
  private _container: ComponentContainer;



  product: ProductDefinition;




  defHideObjects = [
    '_yyy',

  ];

  defShowObjects =  [
    'duvarlar_yyy',
    'zemin_yyy',
    'reflex_yyy',
    'genesis_tekil_masa',
    'genesis_yan_tablali_masa',
    'genesis_toplanti_masa',
    'genesis_workstation',
    'genesis_separator_cam',
    'genesis_etajerli_masa_yyy',
    'xxx',
  ];


  seletedTable: string = GordionTable.Etajer;
  availableAnimations: AnimationDefinition[] = [];
  private _nodeMap: NodeMap[] = null;

  async created() {
    this.product = Store.getProductById('genesis_takim');
    this._configuratorService = this._container.get<ConfiguratorService>(ServiceIdentifiers.ConfiguratorService);

    this.availableAnimations =  [];
    this.availableAnimationsChanged();
    await this._configuratorService.hideObjects({ objects: this.defHideObjects, operator: FilterOperators.Contains });
    await this._configuratorService.showObjects({ objects: this.defShowObjects, operator: FilterOperators.Contains });



    if (Store.state.selection) {
      Store.state.selection.parts.forEach((element) => {
        this.colorChanged(element.color,element.palette,element.id);
      });


    } else {
      await  this.applyDefaultSelection();
    }

  }



  availableAnimationsChanged() {

    this.$emit('availableAnimationsChanged', this.availableAnimations);
  }

  async applyDefaultSelection() {
    const selection = new BasicEtajerliMasaSelection();

    selection.parts = [];

    console.log(this.product.defaults.parts);
    this.product.defaults.parts.forEach((element) => {
      this.colorChanged(element.color,element.palette,element.id);
      const part = new PartSelection();
      part.id = element.id;
      part.color = element.color;
      part.name = element.name;
      part.palette = element.palette;
      selection.parts.push(part);
    });
    Store.state.selection = selection;

  }

  async changeTable(table:GordionTable) {

    if (table === GordionTable.Etajer) {
      await this._configuratorService.hideObjects({ objects: ['genesis_yan_tablali_kesonlu_masa_yyy'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['genesis_etajerli_masa_yyy'], operator: FilterOperators.Contains });
      Store.state.selection.table = GordionTable.Keson;
      this.seletedTable = GordionTable.Keson;
    }
    if (table === GordionTable.Keson) {
      await this._configuratorService.hideObjects({ objects: ['genesis_etajerli_masa_yyy'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['genesis_yan_tablali_kesonlu_masa_yyy'], operator: FilterOperators.Contains });
      Store.state.selection.table = GordionTable.Keson;
      this.seletedTable = GordionTable.Keson;
    }
  }
  isWall: boolean = true;

  async changeWall(wall: boolean) {
    if (wall) {

      await this._configuratorService.showObjects({ objects:  ['duvarlar_yyy'], operator: FilterOperators.Contains });
    } else {


      await this._configuratorService.hideObjects({ objects:  ['duvarlar_yyy'], operator: FilterOperators.Contains });
    }
    this.isWall = wall;
  }

  async colorChanged(color: any,palette: any,part: any) {

    const getPart = this.product.partsPalettes.find(x => x.part === part);
    const getPalettes = Store.state.configuratorConfig.definitions.palettes.find(x => x.id === palette);
    const getColor = getPalettes.colors.find(col => col.name === color);
    await this._configuratorService.changeAlbedoPBR({
      materials: getPart.materials,
      texture: getColor.texture,
    });
    Store.state.selection.parts.find(x => x.id === part).palette = palette;
    Store.state.selection.parts.find(x => x.id === part).color = color;


    if (part === 'genesis_workstation_separator') {

      if (palette === 'pleksi') {
        await this._configuratorService.hideObjects({ objects: ['genesis_separator_yyy'], operator: FilterOperators.Contains });
        await this._configuratorService.showObjects({ objects:  ['genesis_separator_cam_yyy'], operator: FilterOperators.Contains });
      } else {
        await this._configuratorService.hideObjects({ objects:  ['genesis_separator_cam_yyy'], operator: FilterOperators.Contains });
        await this._configuratorService.showObjects({ objects: ['genesis_separator_yyy'], operator: FilterOperators.Contains });

      }

    }
  }

}

export class BasicEtajerliMasaSelection {

  parts: PartSelection[];
}

export class PartSelection {
  id: string;
  palette: string;
  name: string;
  color: string;

}


enum GordionTable {


  Keson = 'keson',
  Etajer = 'etajer',
}



// WEBPACK FOOTER //
// ./src/components/families/genesis/GenesisTakim.ts